import React from "react";

const INSERTABLE_VARIABLES = [
  { token: "{{first_name}}", label: "First Name" },
  { token: "{{last_name}}", label: "Last Name" },
  { token: "{{full_name}}", label: "Full Name" },
  { token: "{{phone_number}}", label: "Phone Number" },
  { token: "{{email}}", label: "Email" },
];

// Cursor-aware token insertion — mirrors MessageComposer.jsx's insertVariable
// exactly (same behavior, same 5 tokens), just extracted into a small,
// standalone piece so the birthday modals don't have to pull in the whole
// heavy MessageComposer (same reasoning as TemplatePickerList).
function insertVariableAtCursor({ textareaRef, message, setMessage, variable }) {
  const textarea = textareaRef.current;
  if (!textarea) return;

  const selectionStart = textarea.selectionStart;
  const selectionEnd = textarea.selectionEnd;
  const messageBefore = message.substring(0, selectionStart);
  const messageAfter = message.substring(selectionEnd);
  const updatedMessage = messageBefore + variable + messageAfter;

  setMessage(updatedMessage);

  setTimeout(() => {
    textarea.focus();
    const newCursorPosition = selectionStart + variable.length;
    textarea.setSelectionRange(newCursorPosition, newCursorPosition);
  }, 0);
}

const VariableInsertButtons = ({ textareaRef, message, setMessage }) => (
  <div className="flex flex-wrap gap-2 items-center mb-2">
    <span className="text-xs font-medium text-gray-500">Insert Parameters:</span>
    {INSERTABLE_VARIABLES.map((variable) => (
      <button
        key={variable.token}
        type="button"
        onClick={() => insertVariableAtCursor({ textareaRef, message, setMessage, variable: variable.token })}
        className="px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded-lg transition-all hover:bg-red-100 hover:border-red-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1"
        title={`Insert ${variable.label} variable`}
      >
        {variable.label}
      </button>
    ))}
  </div>
);

export default VariableInsertButtons;
